<template>
    <div class="card-random block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/ic_image.png" alt="">
                        </div>
                        <h4>Random Number</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <p>Generate random number in range between two numbers and save it at user parameters</p>
                    <label >Random number between</label>
                    <v-layout row wrap>
                        <v-flex xs6>
                            <v-text-field
                                    outline
                                    type="number"
                                    v-model="data.from"
                                    :error="!data.from"
                                    :error-messages="!data.from? 'from is Required':''"
                            >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field
                                    outline
                                    type="number"
                                    v-model="data.to"
                                    :error="!data.to"
                                    :error-messages="!data.to? 'to is Required':''"
                            >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.userAttribute"-->
<!--                                    :error="!data.userAttribute"-->
<!--                                    :error-messages="!data.userAttribute? 'User Attribute is Required':'' "-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.userAttribute" :type="'textfield'"
                                                   :validationRules="autocompleteRandomValidationRules"></vTextareaAutocomplete>
                        </v-flex>

                    </v-layout>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    export default {
        name: "card-image-url",
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common,
                autocompleteRandomValidationRules: [
                    v => !!v || 'User Attribute is Required'
                ]
            }
        },
        mounted() {

        },
        methods: {

        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>